// Adressen som just aktiverats eller fått nytt lösenord följer med till
// inloggningssidan, så fältet inte lämnas åt webbläsarens sparade inloggningar.
// sessionStorage i stället för URL:en: adressen hamnar då varken i historiken eller
// i delade länkar, och den försvinner med fliken. Utan lagring (privat läge) visas
// inloggningssidan bara med ett tomt fält.
const STORAGE_KEY = "loginEmailPrefill";

export const saveLoginEmailPrefill = (email) => {
  if (!email) {
    return;
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, email);
  } catch {
    // Förifyllnaden är en bekvämlighet, inget som får stoppa omdirigeringen.
  }
};

export const readLoginEmailPrefill = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
};

export const clearLoginEmailPrefill = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Se saveLoginEmailPrefill.
  }
};
